import dayjs from 'dayjs';

import type { MatchesCalendarTab } from '../store/types';

export const sortByTabDate = (a: MatchesCalendarTab, b: MatchesCalendarTab) => dayjs(a.date).diff(b.date);
